export enum ERoute {
  ROOT = "/",
}
